// Ticket 20: User Entitlements API

const API_BASE = window.location.origin;

export async function fetchEntitlements() {
  const token = localStorage.getItem('token');
  const res = await fetch(`${API_BASE}/api/me/entitlements`, {
    headers: {
      Authorization: token ? `Bearer ${token}` : '',
    },
  });
  if (!res.ok) throw new Error('Failed to fetch entitlements');
  return res.json();
}
